<template>
  <div class="app-container">
    <div>
      <div class="content">
        <div class="detail">
          <span class="title mr20">{{ shopname }}</span>
          <span class="mr20">摄像头编号：{{ cameraId }}</span>
          <span class="mr20">MAC-ID：{{ macid }}</span>
        </div>
        <div class="live" v-loading="loading">
          <video
            v-show="type === 'flv' && !unsupported"
            id="my-player"
            autoplay
            playsinline
            :muted="needMuted"
            width="800"
            height="600"
          >
            <source type="application/x-mpegURL" />
          </video>
          <video-stream
            v-show="type === 'rtc'"
            class="rtc-player"
            ref="video"
          ></video-stream>
          <p class="live-unsupported" v-if="unsupported">
            当前浏览器无法播放该直播流。iPhone 需升级到 iOS 17.1 及以上，也可改用安卓浏览器或电脑浏览器打开。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flvjs from 'flv.js/dist/flv.js'
import './rtc-lib/video-stream'
import { getoptCamera } from 'src/api/legacy'

export default {
  data() {
    return {
      shopname: '',
      cameraId: this.$route.query.cameraid,
      macid: '',
      copycontent: '',
      src: '',
      sec: 60,
      loading: false,
      type: 'flv',
      unsupported: false,
    }
  },
  computed: {
    // iPhone Safari 没有 MediaSource，只能走 ManagedMediaSource 那条路。
    // Safari 不允许带音轨的视频自动播放，不静音就压根不会播，而这个 <video> 没有
    // controls，用户连手动播的入口都没有。桌面浏览器有 MediaSource，恒为 false，
    // 所以 PC 上的音频行为不变。
    needMuted() {
      return !('MediaSource' in window)
    },
  },
  mounted() {
    this.getoptCamera()
  },
  methods: {
    getReplayUrl(url) {
      const VIDEO_APP_ID = '1255830500'
      if (url.includes('?cameraid=')) {
        return `${url}&seek=${this.sec}`
      } else {
        return `${url}?appid=${VIDEO_APP_ID}&delay=${this.sec}`
      }
    },
    getoptCamera() {
      let data = {
        cameraid: this.cameraId || null,
      }
      this.loading = true
      getoptCamera(data)
        .then((res) => {
          if (res && res.status === 0) {
            // this.cameraId = res.data.cameraid
            this.macid = res.data.macid
            // this.src = this.getReplayUrl(res.data.boxRealtimeUrl);
            this.src = res.data.boxRealtimeUrl
            this.shopname = res.data.shopname
            if (/^wss?:\/\//.test(this.src)) {
              this.playRtc()
            } else {
              this.playFlv()
            }
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    async playFlv() {
      this.type = 'flv'
      this.unsupported = false

      if (flvjs.isSupported()) {
        this.createPlayer(flvjs)
        return
      }

      // 走到这里说明 flv.js 播不了。iPhone Safari 没有 window.MediaSource，
      // 而 flv.js 1.6.2 只认这一个 API，缺了就直接静默不播（没有 else 分支）。
      // iOS 17.1+ 有 ManagedMediaSource，mpegts.js 认它，所以这里换库。
      // 用动态 import 的原因：PC 上 isSupported() 为真，上面就 return 了，
      // 永远走不到这一行，mpegts 的 chunk 在 PC 上不会被下载，首屏体积不变。
      if (!('ManagedMediaSource' in window)) {
        this.unsupported = true
        return
      }

      let mpegts
      try {
        const mod = await import('mpegts.js')
        // UMD 包（main 指向 dist/mpegts.js，没有 module 字段），对象挂在 default 上
        mpegts = mod.default || mod
      } catch (e) {
        this.unsupported = true
        return
      }

      if (!mpegts.isSupported()) {
        this.unsupported = true
        return
      }
      this.createPlayer(mpegts)
    },
    // flv.js 与 mpegts.js 的播放器 API 同名同形，抽出来避免两处重复
    createPlayer(lib) {
      const videoElement = document.getElementById('my-player')
      const player = lib.createPlayer({
        type: 'flv',
        url: this.src,
      })
      player.attachMediaElement(videoElement)
      player.load()
      player.play()
    },
    playRtc() {
      this.type = 'rtc'
      this.$refs.video.src = this.src
    }
  },
}
</script>

<style lang="less" scoped>
.detail {
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d1d1d1;
  margin-bottom: 20px;
}

.title {
  font-size: 16px;
  font-weight: 700;
}

.vjs-error-display.vjs-modal-dialog {
  display: none;
}

.live-unsupported {
  padding: 12px 0;
  color: #f56c6c;
  font-size: 14px;
}

// #my-player 的 800×600 只写在 HTML 属性上，这里没有任何规则覆盖它。
// 窄屏（375px 减去 .app-container 的 24px 内边距，内容区只有 327px）放不下，
// 会横向溢出。属性是表现性提示，优先级低于任何作者规则，所以这一条就能盖住。
// 只在移动断点里改，桌面端维持 800×600 不变。
@media (max-width: 768px) {
  #my-player {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
